import React from "react";
import styles from "./wrapper.module.scss";
import TopNav from "../TopNav";
import { Flex, Layout } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import { Outlet } from "react-router-dom";

const Wrapper = ({ children }) => {

  return (
    <>
      <Flex gap={"middle"} wrap>
        <Layout style={{ width: "100%" }}>
          <Header className={styles.header}>
            <TopNav />
          </Header>
          <Content className={styles.content}>
            <Outlet />
          </Content>
        </Layout>
      </Flex>
    </>
  );
};

export default Wrapper;
